// Replaces the nuxt-lenis module — jcc only needs a single root Lenis
// instance for scrollTo. Pattern adapted from boon, simplified (no
// multi-instance support, no priority RAF scheduler).
import "lenis/dist/lenis.css";
import Lenis from "lenis";

export interface LenisScrollState {
   scroll: number;
   direction: number;
   velocity: number;
   limit: number;
}

export default defineNuxtPlugin(() => {
   const lenis = new Lenis({
      // Skip Lenis on vanilla-cookieconsent's preferences modal so the
      // modal scrolls with native browser behavior. This option used to
      // live on the <Lenis :options> wrapper that nuxt-lenis provided.
      prevent: (node) => node.classList.contains("pm"),
   });

   // Reactive scroll state for components that need scroll position/direction
   // (Header, TOC, Teachable layout). Replaces nuxt-lenis's `useLenis().scrollState`.
   const scrollState = ref<LenisScrollState>({
      scroll: 0,
      direction: 0,
      velocity: 0,
      limit: 0,
   });
   lenis.on("scroll", ({ scroll, direction, velocity, limit }: LenisScrollState) => {
      scrollState.value = { scroll, direction, velocity, limit };
   });

   function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
   }
   requestAnimationFrame(raf);

   return {
      provide: { lenis, lenisScrollState: scrollState },
   };
});
